import config from '../config/config'

const { apiURL } = config
const { identityServerApiURL } = config
const urlConstant = {
  Account: {
    Login: `${apiURL}api/Account/Login`,
    Logout: `${apiURL}api/Account/Logout`,
    ChangePassword: `${apiURL}api/Account/ChangePassword`,
    ResetPassword: `${apiURL}api/Account/ResetPassword`,
  },
  Users: {
    UserList: `${apiURL}api/Users/UserList`,
    CreateUser: `${apiURL}api/Users/Create`,
    DeleteUser: `${apiURL}api/Users/Delete`,
    EditUserById: `${apiURL}api/Users/GetUserDetailById`,
    EditUser: `${apiURL}api/Users/Edit`,
    FactoryUserList: `${apiURL}api/Users/FactoryUserList`,

    RefTypeWiseUserList: `${apiURL}api/Users/RefTypeWiseUserList`,
    DeleteUserAccessRights: `${apiURL}api/Users/DeleteUserAccessRights`,
    GetUserAccessRightsDetailById: `${apiURL}api/Users/GetUserAccessRightsDetailById`,
    EditUserAccessRights: `${apiURL}api/Users/EditUserAccessRights`,
    RoleList: `${apiURL}api/Users/RoleList`,
    FactoryList: `${apiURL}api/Users/FactoryList`,
    AddUserAccessRights: `${apiURL}api/Users/AddUserAccessRights`,
    CheckEmail: `${apiURL}api/Users/CheckEmail`,
    GetDefaultRoleRights: `${apiURL}api/Users/GetDefaultRoleRights`,
    CreateUserAndAddUserAccessRights: `${apiURL}api/Users/CreateUserAndAddUserAccessRights`,
  },
  Factory: {
     FactoryList: `${apiURL}api/FactoryConfig/FactoryList`,
    CreateFactory: `${apiURL}api/FactoryConfig/Create`,
    EditFactory: `${apiURL}api/FactoryConfig/Edit`,
    DeleteFactory: `${apiURL}api/FactoryConfig/Delete`,
    GetFactoryDetailById: `${apiURL}api/FactoryConfig/GetFactoryDetailById`,
    GetFactoryListBySupplierId: `${apiURL}api/FactoryConfig/GetFactoryListBySupplierId`,
    GetFactoryListByClientId: `${apiURL}api/FactoryConfig/GetFactoryListByClientId`,
    GetClientListByFactoryId: `${apiURL}api/FactoryConfig/GetClientListByFactoryId`,
    GetAllFactory: `${apiURL}api/FactoryConfig/GetAllFactory`,
    EditFactoryEmailNotification: `${apiURL}api/FactoryConfig/EditInwardEmail`,
    FileUploadEmailNotification: `${apiURL}api/FactoryConfig/EditUploadfileEmail`,
  },
  Supplier: {
    SupplierList: `${apiURL}api/SupplierConfig/SupplierList`,
    CreateSupplier: `${apiURL}api/SupplierConfig/Create`,
    DeleteSupplier: `${apiURL}api/SupplierConfig/Delete`,
    EditSupplierById: `${apiURL}api/SupplierConfig/GetSupplierDetailById`,
    EditSupplier: `${apiURL}api/SupplierConfig/Edit`,
    GetSuppilerListByFactoryId: `${apiURL}api/SupplierConfig/GetSuppilerListByFactoryId`,
    GetAllSupplier: `${apiURL}api/SupplierConfig/GetAllSupplier`,
  },
  DocumentType: {
    DocumentTypeList: `${apiURL}api/DocumentMediaTypes/DocumentMediaTypesList`,
    CreateDocumentType: `${apiURL}api/DocumentMediaTypes/Create`,
    EditDocumentType: `${apiURL}api/DocumentMediaTypes/Edit`,
    GetDocumentTypeDetailById: `${apiURL}api/DocumentMediaTypes/DocumentMediaTypesDetail`,
    DeleteDocumentType: `${apiURL}api/DocumentMediaTypes/Delete`,
    getDocumentMediaTypeListByRefType: `${apiURL}api/DocumentMediaTypes/DocumentMediaTypesDetailByRefType`,
    getAllDocumentTypes: `${apiURL}api/DocumentMediaTypes/GetAllDocumentTypes`,
  },
  Client: {
    ClientList: `${apiURL}api/ClientDetail/ClientDetailList`,
    CreateClient: `${apiURL}api/ClientDetail/Create`,
    EditClientById: `${apiURL}api/ClientDetail/GetClientDetailById`,
    EditClient: `${apiURL}api/ClientDetail/Edit`,
    DeleteClient: `${apiURL}api/ClientDetail/Delete`,
    GetClientDetailByRefId: `${apiURL}api/ClientDetail/ClientDetailByRefID`,
  },
  ClientFactoryMapping: {
    DeleteClientFactoryMapping: `${apiURL}api/ClientFactoryMapping/Delete`,
    ClientFactoryMappingList: `${apiURL}api/ClientFactoryMapping/ClientFactoryMappingList`,
    ClientFactoryMappingEdit: `${apiURL}api/ClientFactoryMapping/ClientFactoryMappingEdit`,
  },
  SupplierFactoryMapping: {
    DeleteSupplierFactoryMapping: `${apiURL}api/SupplierFactoryMapping/Delete`,
    SupplierFactoryMappingList: `${apiURL}api/SupplierFactoryMapping/SupplierFactoryMappingList`,
    SupplierFactoryMappingEdit: `${apiURL}api/SupplierFactoryMapping/SupplierFactoryMappingEdit`,
  },
  Inward: {
    InwardList: `${apiURL}api/Inward/InwardList`,
    AddInwardDetail: `${apiURL}api/Inward/Create`,
    GetInwardDetailById: `${apiURL}api/Inward/GetInwardDetailById`,
    UpdateInwardDetail: `${apiURL}api/Inward/Edit`,
    DeleteInward: `${apiURL}api/Inward/Delete`,
    upload: `${apiURL}api/InwardDocumentUpload/Upload`,
    ExportCsv: `${apiURL}api/Inward/ExportCsv`,
    GetCertifiedStoneDetailByInwardDetailID: `${apiURL}api/InwardDetail/GetCertifiedStoneDetailByInwardDetailID`,
    AddorEditCertifiedStoneDetail: `${apiURL}api/InwardDetail/AddorEditCertifiedStoneDetail`,
    ExportSelectedData: `${apiURL}api/Inward/ExportSelectedData`,
    UpdateManualInwardDetail: `${apiURL}api/Inward/ManualInwardEdit`,
    AddManualInwardDetail: `${apiURL}api/Inward/ManualInwardCreate`,
    downloadPurchase: `${apiURL}api/Inward/DownloadPurchase`,
  },
  InwardLineSummary: {
    GetSecondInwardList: `${apiURL}api/InwardLineSummary/GetInwardLineSummaryList`,
    GetSecondInwardListById: `${apiURL}api/InwardLineSummary/GetLineSummaryInwardById`,
    addSecondInwardList: `${apiURL}api/InwardLineSummary/LineSummaryInwardCreate`,
    updateSecondInwardList: `${apiURL}api/InwardLineSummary/Edit`,
    deleteSecondInwardList: `${apiURL}api/InwardLineSummary/Delete`,
    getInwardDetailListById: `${apiURL}api/InwardLineSummary/GetInwardDetailById`,
    getInwardById: `${apiURL}api/InwardLineSummary/GetInwardById`,
  },
  OriginsMaster: {
    GetAllOrigin: `${apiURL}api/OriginsMaster/GetAllOrigin`,
    OriginMasterList: `${apiURL}api/OriginsMaster/OriginMasterList`,
    CreateOriginMaster: `${apiURL}api/OriginsMaster/Create`,
    EditOriginMaster: `${apiURL}api/OriginsMaster/Edit`,
    GetOriginMasterDetailById: `${apiURL}api/OriginsMaster/GetOriginMasterDetailById`,
    DeleteOriginMaster: `${apiURL}api/OriginsMaster/Delete`,
    LanguageSpecificOriginMaster: `${apiURL}api/OriginsMaster/LanguageSpecificOriginMaster`,
    LanguageOriginList: `${apiURL}api/OriginsMaster/LanguageOriginList`,
    DeleteLanguage: `${apiURL}api/OriginsMaster/DeleteLanguage/`,
  },
  Document: {
    GetMediaList: `${apiURL}api/DocumentUpload/GetMediaList`,
    SaveDocumentDetail: `${apiURL}api/InwardDocumentUpload/Edit`,
    DeleteDocumentDetail: `${apiURL}api/InwardDocumentUpload/Delete`,
    GetDocumentMediaTypeListByRefType: `${apiURL}api/DocumentMediaTypes/DocumentMediaTypesDetailByRefType`,
    upload: `${apiURL}api/DocumentUpload/Upload`,
    Download: `${apiURL}api/DocumentUpload/DownloadDocument`,
    Delete: `${apiURL}api/DocumentUpload/Delete`,
  },
  UserProfile: {
    upload: `${apiURL}api/Users/ProfilePicUpload`,
    Download: `${apiURL}api/Users/GetProfilePic`,
  },
  JewelryArticle: {
    GetJewelryArticlebyID: `${apiURL}api/JewelryArticle/GetJewelryArticlebyID`,
    GetJewelryArticleDetailsList: `${apiURL}api/JewelryArticle/JewelryArticleDetailsList`,
    GetJewelryArticleList: `${apiURL}api/JewelryArticle/JewelryArticleList`,
    upload: `${apiURL}api/JewelryArticle/Upload`,
    GetAllDocumentsList: `${apiURL}api/JewelryArticle/GetAllDocumentsList`,
    ExportCsv: `${apiURL}api/JewelryArticle/ExportCsv`,
    AddJewelryArticleAuditDetail: `${apiURL}api/JewelryArticle/AddJewelryArticleAuditDetail`,
    GetArticleAuditDetailList: `${apiURL}api/JewelryArticle/GetArticleAuditDetailList`,
    CompleteAudit: `${apiURL}api/JewelryArticle/JewelryArticleAuditComplete`,
    JewelryArticleDisplayImage: `${apiURL}api/JewelryArticle/JewelryArticleDisplayImage`,
    GetJewelryArticleSoldConsumerInfoByArticleID: `${apiURL}api/JewelryArticle/GetJewelryArticleSoldConsumerInfoyArticleID`,
    GetConsumerPersonalizeMomentsListByArticle: `${apiURL}api/JewelryArticle/GetConsumerPersonalizeMomentsListByArticle`,
    SaveArticleSoldConsumerStatus: `${apiURL}api/JewelryArticle/SaveArticleSoldConsumerStatus`,
    GetQRCode: `${apiURL}api/JewelryArticle/GetQRCode`,
    ChangeArticleStatus: `${apiURL}api/JewelryArticle/ChangeArticleStatus`,
    DeleteJewelryByUniqueCode: `${apiURL}api/JewelryArticle/DeleteJewelryByUniqueCode`,
    DocumentUploadDelete: `${apiURL}api/JewelryArticle/DocumentUploadDelete`,
    ExportSelectedData: `${apiURL}api/JewelryArticle/ExportSelectedData`,
    GetDigitalPassInfo: `${apiURL}api/JewelryArticle/GetDigitalPassInfo`,
    JewelryArticleEdit: `${apiURL}api/JewelryArticle/JewelryArticleEdit`,
    GetJeweleryArticleDetailByID: `${apiURL}api/JewelryArticle/GetJeweleryArticleDetailByID`,
    JewelryArticleDetailEdit: `${apiURL}api/JewelryArticle/JewelryArticleDetailEdit`,
  },

  Common: {
    GetUserReferenceDetail: `${apiURL}api/Common/GetUserReferenceDetailByRefId`,
    GetSupportDataByDataType: `${apiURL}api/Common/GetSupportDataByDataType`,
    GetAllSupportDataListByType: `${apiURL}api/Common/GetAllSupportDataListByType`,
  },
  DocumentTypeAccessRights: {
    CheckDocumentAccessRights: `${apiURL}api/AccessRights/CheckDocumentAccessRights`,
    GetAccessRights: `${apiURL}api/AccessRights/GetAccessRightsById`,
    EditAccessRights: `${apiURL}api/AccessRights/Edit`,
  },
  AuditorFactoryMapping: {
    GetFactoryListByAuditorId: `${apiURL}api/AuditorFactoryMapping/GetFactoryListByAuditorId`,
  },

  ApiCreadatial: {
    APICredentialDetail: `${apiURL}api/APICredential/APICredentialDetail`,
    AddOrUpdateClientSecret: `${identityServerApiURL}Clients/AddOrUpdateClientSecret`,
    UpdateClientSecret: `${identityServerApiURL}Clients/UpdateClientSecret`,
    APICredentialEdit: `${apiURL}api/APICredential/APICredentialEdit`,
    getClientData: `${identityServerApiURL}Clients/GetClientData`,
  },
  Consumer: {
    CheckConsumer: `${apiURL}api/Consumer/CheckConsumer`,
    GetDocument: `${apiURL}api/Consumer/GetDocument`,
    CreateConsumerPersonalizeMoments: `${apiURL}api/ConsumerPersonalizeInfo/CreateConsumerPersonalizeMoments`,
    VerifyOTP: `${apiURL}api/ConsumerPersonalizeInfo/VerifyOTP`,
    ResendOTP: `${apiURL}api/ConsumerPersonalizeInfo/ResendOTP`,
    SaveConsumerPersonalizeMomentDetail: `${apiURL}api/ConsumerPersonalizeInfo/SaveConsumerPersonalizeMomentDetail`,
    GetConsumerPersonalizeMomentImage: `${apiURL}api/ConsumerPersonalizeInfo/GetConsumerPersonalizeMomentImage`,
    UpdatePersonalizeMomentStatus: `${apiURL}api/ConsumerPersonalizeInfo/UpdatePersonalizeMomentStatus`,
    ConsumerByUniqueCode: `${apiURL}api/Consumer/ConsumerByUniqueCode`,
    CheckConsumerPersonalizeEmail: `${apiURL}api/ConsumerPersonalizeInfo/CheckConsumerkPersonalizeEmail`,
    GetPersonalizeMomentsByGuid: `${apiURL}api/ConsumerPersonalizeInfo/GetPersonalizeMomentsByGuid`,
    GetPersonalizeMomentsByMomentID: `${apiURL}api/ConsumerPersonalizeInfo/GetPersonalizeMomentsByMomentID`,
    GetOriginsByArticleID: `${apiURL}api/Consumer/GetOriginsByArticleID`,
    GetCertifiedStoneDetailsByUniqueCode: `${apiURL}api/ConsumerPersonalizeInfo/GetCertifiedStoneDetailsByUniqueCode`,
    GetCountryOfOriginsByArticleID: `${apiURL}api/Consumer/GetCountryOfOriginsByArticleID`,
    GetJewelleryArticleInfo: `${apiURL}api/Consumer/GetJewelleryArticleInfo`,
    Download: `${apiURL}api/Consumer/GenerateTracemarkCertificate`,
    GetPanelByLanguage: `${apiURL}api/Consumer/GetPanelByLanguage`,
    getLanguageDropdownData: `${apiURL}api/Consumer/GetLanguageDropdown`,
    DownloadBatchCertificate: `${apiURL}api/Consumer/GenerateBatchTracemarkCertificate`,
  },
  AuditLogs: {
    AddAuditLogs: `${apiURL}api/AuditLogs/AddAuditLogs`,
    GetAuditLogs: `${apiURL}api/AuditLogs/GetAuditLogs`,
    CompleteSupplierAudit: `${apiURL}api/AuditLogs/SupplierAuditComplete`,
    CompleteInwardAudit: `${apiURL}api/AuditLogs/InwardAuditComplete`,
    CompleteJewelryArticleAudit: `${apiURL}api/AuditLogs/JewelryArticleAuditComplete`,
  },
  ImportCSV: {
    DownloadImportSampleCSV: `${apiURL}api/Common/DownloadImportSampleCSV`,
    JewelryArticleImport: `${apiURL}api/JewelryArticle/JewelryArticleImport`,
    InwardImport: `${apiURL}api/Inward/InwardImport`,
    RMCodeImportAPI: `${apiURL}api/RMCode/RMCodeImport`,
  },
  BulkUpload: {
    AddBulkUploadFolder: `${apiURL}api/BulkUpload/AddBulkUploadFolder`,
    GetBulkUploadList: `${apiURL}api/BulkUpload/GetBulkUploadList`,
    DeleteBulkUpload: `${apiURL}api/BulkUpload/BulkUploadDelete`,
  },
  RMCode: {
    GetRMCodeList: `${apiURL}api/RMCode/RMCodeList`,
    SaveRMCode: `${apiURL}api/RMCode/RMCodeCreate`,
    EditRMCode: `${apiURL}api/RMCode/RMCodeEdit`,
    DeleteRMCode: `${apiURL}api/RMCode/RMCodeDelete`,
    GetRMCodeDetailById: `${apiURL}api/RMCode/GetRMCodeDetailById`,
    GetRMCodeDetails: `${apiURL}api/RMCode/GetRMCodeDetails`,
    GetRMCodeDropDownList: `${apiURL}api/RMCode/GetRMCodeDropDownList`,
  },
  JewelryArticleTransfer: {
    GetTransferToList: `${apiURL}api/JewelryArticleTransfer/GetTransferToList`,
    CreateJewelryArticleTransfer: `${apiURL}api/JewelryArticleTransfer/JewelryArticleTransferCreate`,
    GetAllTransactionList: `${apiURL}api/JewelryArticleTransfer/GetAllTransactionList`,
    GetTransferToListWithEntityType: `${apiURL}api/JewelryArticleTransfer/GetTransferToListWithEntityType`,
    GetTransferTransactionDetailList: `${apiURL}api/JewelryArticleTransfer/GetTransferTransactionDetailList`,
    upload: `${apiURL}api/JewelryArticleTransfer/Upload`,
    DeleteDocument: `${apiURL}api/JewelryArticleTransfer/Delete`,
    GetReceivedTransferList: `${apiURL}api/JewelryArticleTransfer/ArticleReceivedTransferList`,
    JewelleryArticleTransferDelete: `${apiURL}api/JewelryArticleTransfer/JewelleryArticleTransferDelete`,
    ReceivedTransferAckStatusChange: `${apiURL}api/JewelryArticleTransfer/ReceivedTransferAckStatusChange`,
    GetJewelleryArticleTransferById: `${apiURL}api/JewelryArticleTransfer/JewelleryArticleTransferById`,
  },
  Dashboard: {
    GetEntityDetails: `${apiURL}api/Dashboard/GetEntityDetails`,
    GetCompanyName: `${apiURL}api/Dashboard/GetCompanyName`,
  },
  OriginCountryMaster: {
    OriginCountryList: `${apiURL}api/OriginCountryConfig/OriginCountryList`,
    OriginCountryCreate: `${apiURL}api/OriginCountryConfig/Create`,
    GetOriginCountryDetailById: `${apiURL}api/OriginCountryConfig/GetOriginCountryDetailById`,
    OriginCountryEdit: `${apiURL}api/OriginCountryConfig/Edit`,
    OriginCountryDelete: `${apiURL}api/OriginCountryConfig/Delete`,
    GetAllCountriesOfOrigin: `${apiURL}api/OriginCountryConfig/GetAllCountriesOfOrigin`,
    LanguageCountryofOrigin: `${apiURL}api/OriginCountryConfig/LanguageSpecificOriginCountry`,
    LanguageCountryofOriginList: `${apiURL}api/OriginCountryConfig/LanguageOriginCountryList`,
    LanguageCountryofOriginDelete: `${apiURL}api/OriginCountryConfig/DeleteCountryLanguage`,
  },
  ErrorLog: {
    AddErrorLog: `${apiURL}api/UIErrorLog/AddUIErrorLog`,
    ErrorLogList: `${apiURL}api/ErrorLog/ErrorLogList`,
  },
  UIErrorLog: {
    AddErrorLog: `${apiURL}api/UIErrorLog/AddUIErrorLog`,
    UIErrorLogList: `${apiURL}api/UIErrorLog/UIErrorLogList`,
  },
  Menu: {
    GetMenuData: `${apiURL}api/Menu/GetMenuData`,
  },
  QRCode: {
    SaveQRCodeMappingDetail: `${apiURL}api/QRCode/SaveQRCodeMappingDetail`,
    GetQRCodeDetails: `${apiURL}api/QRCode/GetQRCodeDetails`,
    GetAllUniqueCodes: `${apiURL}api/QRCode/GetAllUniqueCodes`,
    GetDataByQRUniqueCode: `${apiURL}api/QRCode/GetDataByQRUniqueCode`,
    UnmapQRCode: `${apiURL}api/QRCode/UnmapQRCode`,
    GetAllCertReportNos: `${apiURL}api/QRCode/GetAllCertReportNos`,
  },
  CertifiedStoneTransfer: {
    GetCertifiedStoneTransferRequest: `${apiURL}api/CertifiedStoneTransfer/GetCertifiedStoneTransferRequest`,
    ReceivedTransferAckStatusChange: `${apiURL}api/CertifiedStoneTransfer/TransferRequestAckStatusChange`,
    GetTransferTransactionDetailList: `${apiURL}api/CertifiedStoneTransfer/GetTransferTransactionDetailList`,
    GetCertifiedStoneTransferById: `${apiURL}api/CertifiedStoneTransfer/CertifiedStoneTransferById`,
    GetAllTransactionList: `${apiURL}api/CertifiedStoneTransfer/GetAllCertifiedStoneTransactionList`,
    CertifiedStoneTransferDelete: `${apiURL}api/CertifiedStoneTransfer/CertifiedStoneTransferDelete`,
    CertifiedStoneTransferCreate: `${apiURL}api/CertifiedStoneTransfer/CertifiedStoneTransferCreate`,
    upload: `${apiURL}api/CertifiedStoneTransfer/Upload`,
    DeleteDocument: `${apiURL}api/CertifiedStoneTransfer/Delete`,
  },
  CertifiedStone: {
    GetCertiFiedStoneList: `${apiURL}api/CertifiedStone/GetCertiFiedStoneList`,
    ExportCsv: `${apiURL}api/CertifiedStone/ExportCsv`,
    DeleteCertifiedStoneByCertRepNo: `${apiURL}api/CertifiedStone/DeleteCertifiedStoneByCertRepNo`,
    ChangeCertifiedStoneStatus: `${apiURL}api/CertifiedStone/ChangeCertifiedStoneStatus`,
    upload: `${apiURL}api/CertifiedStone/Upload`,
    GetCertifiedStonebyID: `${apiURL}api/CertifiedStone/GetCertifiedStonebyID`,
    GetAllCertifiedStoneDocumentsList: `${apiURL}api/CertifiedStone/GetAllCertifiedStoneDocumentsList`,
    DocumentUploadDelete: `${apiURL}api/CertifiedStone/DocumentUploadDelete`,
    ExportSelectedData: `${apiURL}api/CertifiedStone/ExportSelectedData`,
  },
  CertifiedStoneTraceability: {
    GetCertifiedStoneDetail: `${apiURL}api/CertifiedStoneTraceability/GetCertifiedStoneDetail`,
    GetDocument: `${apiURL}api/CertifiedStoneTraceability/GetDocument`,
    GetCertificateByTLSId: `${apiURL}api/CertifiedStoneTraceability/GetCertificateByTLSId`,
  },
  UserSwitchAccount: {
    GetUserAppAccessRightsByTenant: `${apiURL}api/Users/GetUserAppAccessRightsByTenant`,
  },
  RoleRights: {
    GetUserAccessRights: `${apiURL}api/RoleRights/GetUserAccessRights`,
    GetRoleRightsList: `${apiURL}api/RoleRights/GetRoleRightsList`,
    GetRoleRightsById: `${apiURL}api/RoleRights/GetRoleRightsById`,
    Edit: `${apiURL}api/RoleRights/Edit`,
  },
  TenantConfig: {
    GetTenantLogo: `${apiURL}api/TenantConfig/GetTenantLogo`,
    GetTenantDetailById: `${identityServerApiURL}TenantConfig/GetTenantDetailById`,
    EditTenant: `${identityServerApiURL}TenantConfig/EditTenant`,
  },
  Impersonate: {
    DeleteImpersonateLoginGUID: `${identityServerApiURL}Account/DeleteImpersonateLoginGUID`,
    UserImpersonateLogout: `${identityServerApiURL}Account/UserImpersonateLogout`,
    GenerateImpersonateLoginGUID: `${identityServerApiURL}Account/GenerateImpersonateLoginGUID`,
    UserImpersonate: `${identityServerApiURL}Account/UserImpersonate`,
  },
  SpecilizationMst: {
    SpecilizationList: `${apiURL}api/SpecilizationMstConfig/SpecilizationList`,
    CreateSpecilization: `${apiURL}api/SpecilizationMstConfig/Create`,
    EditSpecilization: `${apiURL}api/SpecilizationMstConfig/Edit`,
    GetSpecilizationDetailById: `${apiURL}api/SpecilizationMstConfig/GetSpecilizationDetailById`,
    DeleteSpecilization: `${apiURL}api/SpecilizationMstConfig/Delete`,
    GetAllSpecialization: `${apiURL}api/SpecilizationMstConfig/GetAllSpecialization`,
  },
  AttributeMst: {
    CreateAttribute: `${apiURL}api/AttributeMstConfig/Create`,
    AttributeList: `${apiURL}api/AttributeMstConfig/AttributeList`,
    GetAttributeDetailById: `${apiURL}api/AttributeMstConfig/GetAttributeDetailById`,
    EditAttribute: `${apiURL}api/AttributeMstConfig/Edit`,
    DeleteAttribute: `${apiURL}api/AttributeMstConfig/Delete`,
  },
  CountryMst: {
    CountryList: `${apiURL}api/CountryMstConfig/CountryList`,
    CreateCountry: `${apiURL}api/CountryMstConfig/Create`,
    GetCountryDetailById: `${apiURL}api/CountryMstConfig/GetCountryDetailById`,
    EditCountry: `${apiURL}api/CountryMstConfig/Edit`,
    DeleteCountry: `${apiURL}api/CountryMstConfig/Delete`,
    GetAllCountry: `${apiURL}api/CountryMstConfig/GetAllCountry`,
  },
  StateMst: {
    StateList: `${apiURL}api/StateMstConfig/StateList`,
    CountryList: `${apiURL}api/StateMstConfig/CountryList`,
    CreateState: `${apiURL}api/StateMstConfig/Create`,
    EditState: `${apiURL}api/StateMstConfig/Edit`,
    GetStateDetailById: `${apiURL}api/StateMstConfig/GetStateDetailById`,
    DeleteState: `${apiURL}api/StateMstConfig/Delete`,
    stateDropDownList: `${apiURL}api/StateMstConfig/StateDropDownList`,
  },
  IdentityClient: {
    CreateIdentityApplicationClient: `${identityServerApiURL}Clients/ManageApplicationClients`,
    UpdateAppicationClient: `${identityServerApiURL}Clients/UpdateAppicationClient`,
    EditIdentityApplicationClientID: `${apiURL}api/ClientDetail/EditIdentityApplicationClientID`,
  },
  ClientContactInfo: {
    ClientContactInfoList: `${apiURL}api/ClientContactPersonDetail/ClientContactPersonDetailList`,
    CreateClientContactInfo: `${apiURL}api/ClientContactPersonDetail/Create`,
    EditClientContactInfoById: `${apiURL}api/ClientContactPersonDetail/GetClientContactDetailById`,
    EditClientContactInfo: `${apiURL}api/ClientContactPersonDetail/Edit`,
    DeleteClientContactInfo: `${apiURL}api/ClientContactPersonDetail/Delete`,
  },
  WholesalerFactoryMapping: {
    WholesalerFactoryMappingList: `${apiURL}api/WholesalerFactoryMapping/WholesalerFactoryMappingList`,
    WholesalerFactoryMappingEdit: `${apiURL}api/WholesalerFactoryMapping/WholesalerFactoryMappingEdit`,
  },
  PKPass: {
    VerifyTLSUniqueCode: `${apiURL}api/PKPass/VerifyTLSUniqueCode`,
    StoreConsumerDetails: `${apiURL}api/PKPass/StoreConsumerDetails`,
    GeneratePass: `${apiURL}api/PKPass/GeneratePass`,
    CheckIfArticleConfigured: `${apiURL}api/PKPass/CheckIfArticleConfigured`,
    VerifyConsumerPassword: `${apiURL}api/PKPass/VerifyConsumerPassword`,
    VerifyDetailsAndGenerateOTP: `${apiURL}api/PKPass/VerifyDetailsAndGenerateOTP`,
    ResetConsumerPersonalizeMomentsPassword: `${apiURL}api/PKPass/ResetConsumerPersonalizeMomentsPassword`,
    DeleteTracemarkID: `${apiURL}api/PKPass/DeleteTracemarkID`,
    TousDigitalPass: `${apiURL}api/PKPass/GenerateTousDigitalPass`,
    TracemarkDigitalPass: `${apiURL}api/PKPass/GenerateTracemarkDigitalPass`,
    saveBatchComponentAccessHistory: `${apiURL}api/PKPass/SaveBatchComponentAccessHistory`,
    generateBatchComponentDigitalPass: `${apiURL}api/PKPass/GenerateBatchComponentDigitalPass`,
    VerifyBatchTLSUniqueCode: `${apiURL}api/PKPass/VerifyBatchTLSUniqueCode`,
  },
  JewelryArticleInfo: {
    getJewelryArticleInfoList: `${apiURL}api/JewelryArticleInfo/JewelryArticleInfoList`,
    AddJewelryArticleInfo: `${apiURL}api/JewelryArticleInfo/AddJewelryArticleInfo`,
    EditJewelryArticleInfo: `${apiURL}api/JewelryArticleInfo/EditJewelryArticleInfo`,
    DeleteJewelryArticleInfo: `${apiURL}api/JewelryArticleInfo/DeleteJewelryArticleInfo`,
    GetJeweleryArticleInfoById: `${apiURL}api/JewelryArticleInfo/GetJeweleryArticleInfoById`,
    getArticleCodeList: `${apiURL}api/JewelryArticleInfo/GetArticleCode`,
  },
  Panel: {
    getPanelList: `${apiURL}api/DynamicPanel/GetPanelList`,
    getPanelDetailList: `${apiURL}api/DynamicPanel/GetPanelDetailList`,
    create: `${apiURL}api/DynamicPanel/Create`,
    getPanelDetailsById: `${apiURL}api/DynamicPanel/GetPanelDetailsByID`,
    edit: `${apiURL}api/DynamicPanel/Edit`,
    delete: `${apiURL}api/DynamicPanel/Delete`,
    publishPanel: `${apiURL}api/DynamicPanel/PublishPanel`,
    getPanelDropdownList: `${apiURL}api/DynamicPanel/GetPanelDropdown`,
    getPanelsById: `${apiURL}api/DynamicPanel/GetPanelByID`,
    editPanel: `${apiURL}api/DynamicPanel/EditPanel`,
    deletePanel: `${apiURL}api/DynamicPanel/DeletePanel`,
    getCopiedPanel: `${apiURL}api/DynamicPanel/GetCopiedPanel`,
    checkDraftExist: `${apiURL}api/DynamicPanel/CheckDraftExist`,
    GetDocumentType: `${apiURL}api/DynamicPanel/DocumentType`,
    componentImageUpload: `${apiURL}api/DynamicPanel/ComponentImageUpload`,
    createCopyPanelList: `${apiURL}api/DynamicPanel/CreateCopyPanelList`,
  },
  ClientPanelPreferences: {
    getClientPanel: `${apiURL}api/ClientPanel/getClientPanel`,
    SaveClientPreferences: `${apiURL}api/ClientPanel/SaveClientPanelDetail`,
    GetClientPanelLogo: `${apiURL}api/ClientPanel/GetClientPanelLogo`,
    getClientPanelLogo: `${apiURL}api/ClientPanel/GetClientPanelLogoByTLSID`,
    ResetClientPanelDetail: `${apiURL}api/ClientPanel/ResetClientPanelDetail`,
  },
  LanguageMaster: {
    getLanguageMasterList: `${apiURL}api/LanguageMaster/GetLanguageList`,
    getLanguageMasterListById: `${apiURL}api/LanguageMaster/GetLanguageListByID`,
    create: `${apiURL}api/LanguageMaster/Create`,
    edit: `${apiURL}api/LanguageMaster/Edit`,
    delete: `${apiURL}api/LanguageMaster/Delete`,
    languageDropDown: `${apiURL}api/LanguageMaster/GetLanguageMasterDropdown`,
  },
  uploadfactory: {
    uploadFactory: `${apiURL}api/FactoryDocumentUpload/Upload`,
    Download: `${apiURL}api/FactoryDocumentUpload/DownloadDocument`,
  },
  FactoryMedia:{
    FactoryMediaList: `${apiURL}api/FactoryDocumentUpload/GetFactoryMediaList`,
  }
}

export { urlConstant as default }
